// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b36f5609","159":"c7ba5576"}[chunkId] + ".chunk.js";
};